import uniq from 'lodash/uniq';
import PropTypes from 'prop-types';
import React from 'react';
import { Trans } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { Badge } from '@shared/ui/components/Badge';

import Confirm from '../../../../base/Confirm';
import ListView from '../../../../base/ListView';
import ModalToBody from '../../../../base/ModalToBody';
import { toImmutable } from '../../../../libs/immutable-transformer';
import { ajaxErrorHandler, defaultCrewProps, defaultSuccess } from '../../../../libs/utils';
import { CREW_MEMBERS_ACTIONS } from '../../../../redux/crewMembers/actions';
import { crewMembersMeta, selectActiveCrewMember, selectCrewMembers } from '../../../../redux/crewMembers/selectors';
import { createCrewMember, getCrewMember, updateCrewMember } from '../../../../services/api/crewMembers';
import { getRegistrationParkings } from '../../../../services/api/registrationParkings';
import { generateVouchers, uploadTemplate } from '../../../../services/api/registrations';
import { createUser, getUsers } from '../../../../services/api/users';
import CopyBtn from '../../../company/crew/partials/CopyBtn';
import CrewMemberForm from '../../../forms/CrewMemberForm';
import CrewMembersOverviewButton from '../../../shared/crewMembers/OverviewButton';
import SendVouchersToCrewMemberButton from '../../../shared/crewMembers/SendVouchersToCrewMemberButton';
import ShowAdminsButton from '../../../shared/crewMembers/ShowAdminsButton';
import CrewMemberZones from './CrewMemberZones';
import CrewMemberDropzone from './components/CrewMemberDropzone';

class _CrewMembers extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      typeaheadUsers: [],
      selectedUser: [],
      showModal: false,
      registration: undefined,
      isSubmitting: false,
      activeCrewMember: undefined,
      filtersUpdated: false,
      eventDays: [],
      baseFilters: toImmutable({
        'page[number]': 1,
        'page[size]': 10,
        'sort': '-updated_at',
        'include': 'user,profile,documents,crewMemberAccesses.zone',
        'filter[registration_id]': this.props.registration.id,
      }),
    };

    this._closeModal = this._closeModal.bind(this);
    this._openModal = this._openModal.bind(this);
    this._handleSubmit = this._handleSubmit.bind(this);
    this._handleDelete = this._handleDelete.bind(this);
    this._handleSearch = this._handleSearch.bind(this);
    this._handleChange = this._handleChange.bind(this);
    this._doneSubmitting = this._doneSubmitting.bind(this);
    this._customActions = this._customActions.bind(this);
    this._handleFilterUpdate = this._handleFilterUpdate.bind(this);
  }

  static propTypes = {
    ...defaultCrewProps,
    deleteCrewMember: PropTypes.func,
    crewMembers: PropTypes.array,
    crewMembersMeta: PropTypes.object,
    history: PropTypes.object,
    event: PropTypes.object,
  };

  UNSAFE_componentWillMount() {
    this.setState({ registration: this.props.registration });

    this.props.updateFilters(this.state.baseFilters);

    if (this.props.match.params.crewId) {
      this._openEditForCrewId(this.props.match.params.crewId);
    }

    getRegistrationParkings(this.props.registration.id).then((response) => {
      if (response.data.length > 0) {
        this.setState({
          eventDays: response.data[0].enforcedDays,
        });
      }
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.match.params.crewId && !this.props.match.params.crewId) {
      this._openEditForCrewId(nextProps.match.params.crewId);
    }

    if (!nextProps.match.params.crewId && this.props.match.params.crewId) {
      this._closeModal();
    }
  }

  _handleFilterUpdate(filters) {
    this.setState({
      filtersUpdated: true,
    });
    this.props.updateFilters(filters);
  }

  _closeModal(close = true) {
    if (close) {
      this.props.history.push('/admin/registrations/' + this.props.registration.id + '/edit/crew');
      this.setState({
        activeCrewMember: undefined,
      });
      document.body.classList.remove('modal-open');
    } else {
      document.body.classList.add('modal-open');
    }

    this.setState({
      showModal: !close,
    });
  }

  _openModal() {
    this._closeModal(false);
  }

  _openEditForCrewId(id) {
    getCrewMember(id)
      .then((response) => {
        this.setState({
          activeCrewMember: response,
        });
      })
      .catch(ajaxErrorHandler);
    this._openModal();
  }

  _handleSubmit(values) {
    this.setState({
      isSubmitting: true,
    });

    console.log('handleSubmit!', values);

    if (!values.userId || values.userId === '') {
      createUser({
        firstName: values.firstName,
        lastName: values.lastName,
        companyIds: [this.props.registration.companyId],
      }).then((response) => {
        const data = {
          userId: response.id,
          registrationId: this.props.registration.id,
          profileId: values.profileId,
          occupation: values.occupation,
          camping: values.camping ?? false,
          allowCombiVouchers: values.allowCombiVouchers ?? false,
          days: values.days,
          dietaryPreferences: values.vegetarian ? ['vegetarian'] : [],
        };
        console.log('handleSubmit - createUser', data);

        createCrewMember(data)
          .then((response) => {
            this._doneSubmitting();
            if (values.vouchers) {
              generateVouchers(this.props.registration.id, {
                priority: true,
                crewMemberId: response.id,
                sendVouchers: false,
              })
                .then((reponse) => {
                  defaultSuccess('Vouchers are being generated, please give the server a few seconds.');
                })
                .catch(ajaxErrorHandler);
            }
          })
          .catch(ajaxErrorHandler);
      });
    } else {
      const data = {
        userId: values.userId,
        registrationId: this.props.registration.id,
        profileId: values.profileId,
        occupation: values.occupation,
        camping: values.camping ?? false,
        allowCombiVouchers: values.allowCombiVouchers ?? false,
        days: values.days,
        dietaryPreferences: values.vegetarian ? ['vegetarian'] : [],
      };

      console.log('handleSubmit - updateUser', data);

      if (values.id) {
        // update
        updateCrewMember(values.id, data)
          .then((response) => {
            this._doneSubmitting();
            if (values.vouchers) {
              generateVouchers(this.props.registration.id, {
                priority: true,
                crewMemberId: values.id,
                sendVouchers: false,
              })
                .then((reponse) => {
                  defaultSuccess('Vouchers are being generated, please give the server a few seconds.');
                })
                .catch(ajaxErrorHandler);
            }
          })
          .catch(ajaxErrorHandler);
      } else {
        console.log('handleSubmit - generateVouchers', data);

        //create
        createCrewMember(data)
          .then((response) => {
            this._doneSubmitting();
            if (values.vouchers) {
              generateVouchers(this.props.registration.id, {
                priority: true,
                crewMemberId: response.id,
                sendVouchers: false,
              })
                .then((reponse) => {
                  defaultSuccess('Vouchers are being generated, please give the server a few seconds.');
                })
                .catch(ajaxErrorHandler);
            }
          })
          .catch(ajaxErrorHandler);
      }
    }
  }

  _doneSubmitting() {
    this.props.updateFilters(this.state.baseFilters);
    this._closeModal();
    this.setState({
      isSubmitting: false,
    });
  }

  _handleDelete(id) {
    Confirm('Are you sure you want to delete this Crew Member?', {
      title: 'Delete Crew Member',
      confirmStyle: 'btn-danger',
      confirmText: 'Delete',
    }).then(
      (result) => {
        this.props.deleteCrewMember(id);
      },
      (result) => {}
    );
  }

  _handleSearch(value) {
    getUsers({
      'filter[company_id]': this.state.registration.company.id,
      'filter[name]': value,
    }).then((response) => {
      this.setState({
        typeaheadUsers: response.data,
      });
    });
  }

  _handleChange(value) {
    this.setState({
      selectedUser: value,
    });
  }

  _customActions(item) {
    return (
      <>
        <SendVouchersToCrewMemberButton crewMember={item} />

        <CrewMemberZones crewMember={item} event={this.props.event} eventDays={this.state.eventDays} />
      </>
    );
  }

  render() {
    const { showModal, registration, activeCrewMember, baseFilters, filtersUpdated, errors } = this.state;
    const { event, crewMembers, crewMembersMeta } = this.props;

    const listViewConf = {
      dataSet: crewMembers,
      dataMeta: crewMembersMeta,
      columns: [
        {
          key: 'name',
          value: 'Name',
          render: (crewMembers) => crewMembers.user.firstName + ' ' + crewMembers.user.lastName,
        },
        {
          key: 'profile',
          value: 'Profile',
          render: (crewMembers) => {
            const additionalZones = uniq(crewMembers.crewMemberAccesses.map((access) => access.zone.code)).join('');

            return (
              <div className="space-x-2">
                <span>{crewMembers.profile.name}</span>
                {additionalZones && <Badge variant="outlineDestructive">{additionalZones}</Badge>}
              </div>
            );
          },
        },
        {
          key: 'occupation',
          value: 'Function',
          render: (crewMembers) => crewMembers.occupation,
        },
        {
          key: 'documents',
          value: '',
          render: (crewMember) => crewMember.documents.map((doc) => <i key={doc.id} className="la la-file" />),
        },
      ],
      filters: [
        {
          label: 'Name',
          icon: 'la-search',
          type: 'text',
          key: 'name_like',
        },
        {
          label: 'Profile',
          icon: 'la-user',
          key: 'profile_id',
          type: 'select',
          dataset: registration.registrationProfiles.map(({ profile }) => {
            return {
              key: profile.id,
              value: profile.name,
            };
          }),
        },
        {
          label: 'Day',
          key: 'for_day',
          icon: 'la-calendar',
          type: 'datepicker',
        },
      ],
      baseFilters,
      actions: {
        deleteLink: true,
        editLink: true,
        detailsLink: false,
        deleteFunction: this._handleDelete,
        customLink: this._customActions,
      },
      url: '/admin/registrations/' + registration.id + '/edit/crew',
    };

    return (
      <div className="row">
        <div className="col-xl-12">
          <div className="m-portlet">
            <div className="m-portlet__head">
              <div className="m-portlet__head-caption">
                <div className="m-portlet__head-title" />
              </div>

              <div className="m-portlet__head-tools">
                <form>
                  {((crewMembers && crewMembers.length > 0) || filtersUpdated) && (
                    <ul className="m-portlet__nav" style={{ float: 'left' }}>
                      <li className="m-portlet__nav-item">
                        <CopyBtn
                          company={registration.company}
                          event={event}
                          registration={registration}
                          loadCrewMembers={() => this.props.updateFilters(this.state.baseFilters)}
                          admin
                        />
                      </li>
                    </ul>
                  )}
                  <ul className="m-portlet__nav m--margin-left-20">
                    <li className="m-portlet__nav-item">
                      <CrewMembersOverviewButton registrationProfiles={registration.registrationProfiles} />
                    </li>
                    <li className="m-portlet__nav-item">
                      <ShowAdminsButton companyId={registration.company.id} />
                    </li>
                    <li className="m-portlet__nav-item">
                      <button
                        type="button"
                        className="m-portlet__nav-link btn btn-primary m-btn m-btn--icon"
                        onClick={this._openModal}
                      >
                        <span>
                          <i className="la la-plus" />
                          <span>
                            <Trans>CrewMemberAddButton</Trans>
                          </span>
                        </span>
                      </button>
                    </li>
                  </ul>
                </form>
              </div>
            </div>
          </div>

          {errors && (
            <div className="col-xl-12 ">
              <div className="alert alert-danger">
                <h4>Upload failed.</h4>
                {Object.entries(errors).map((row) => (
                  <p key={row[0]}>
                    <strong>Row {row[0]}</strong> <br />
                    <ul>
                      {Object.entries(row[1]).map((error) => (
                        <li key={error[0]}>{error[1]}</li>
                      ))}
                    </ul>
                  </p>
                ))}
              </div>
            </div>
          )}

          <div className="row">
            <div className="col-lg-12">
              {(crewMembers && crewMembers.length > 0) || filtersUpdated ? (
                <ListView
                  config={listViewConf}
                  handleDelete={this._handleDelete}
                  handleFilterUpdate={this._handleFilterUpdate}
                />
              ) : (
                <div className="alert alert-info">
                  <Trans>frontend.crew.noCrewMembersMsg</Trans>
                </div>
              )}
            </div>
            <div className="col-lg-12">{registration && <CrewMemberDropzone registration={registration} />}</div>
          </div>
        </div>
        <ModalToBody>
          <div
            className="modal fade show"
            id="m_modal_4"
            tabIndex="-1"
            role="dialog"
            aria-labelledby="exampleModalLabel"
            style={{
              display: showModal ? 'block' : 'none',
              zIndex: '1039',
            }}
          >
            {showModal && (
              <div className="modal-dialog modal-lg" role="document">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title" id="exampleModalLabel">
                      New Crew Member for {event.name}
                    </h5>
                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                      onClick={this._closeModal}
                    >
                      <span aria-hidden="true">×</span>
                    </button>
                  </div>

                  {registration && (
                    <CrewMemberForm
                      event={event}
                      registration={registration}
                      crewMember={activeCrewMember}
                      close={this._closeModal}
                      onSubmit={this._handleSubmit}
                      visible={showModal}
                      admin
                    />
                  )}
                </div>
              </div>
            )}
          </div>

          <div
            className={'modal-backdrop fade ' + (showModal ? ' show' : '')}
            style={{
              display: showModal ? 'block' : 'none',
              zIndex: '1038',
            }}
          />
        </ModalToBody>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  deleteCrewMember: (id) => dispatch(CREW_MEMBERS_ACTIONS.deleteRequest(id)),
  updateFilters: (filters) => dispatch(CREW_MEMBERS_ACTIONS.updateFilters(filters)),
});

const mapStateToProps = function (state) {
  return {
    crewMembers: selectCrewMembers(state),
    crewMembersMeta: crewMembersMeta(state),
    activeCrewMember: selectActiveCrewMember(state),
  };
};

const CrewMembers = withRouter(connect(mapStateToProps, mapDispatchToProps)(_CrewMembers));

export default CrewMembers;
